import { render, staticRenderFns } from "./GlobalMonitorPage.vue?vue&type=template&id=7be95887&scoped=true&"
import script from "./GlobalMonitorPage.vue?vue&type=script&lang=js&"
export * from "./GlobalMonitorPage.vue?vue&type=script&lang=js&"
import style0 from "./GlobalMonitorPage.vue?vue&type=style&index=0&id=7be95887&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be95887",
  null
  
)

export default component.exports